import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Login from './pages/Login/Login';
import Support from './pages/Support/Support';
import Profile from './pages/Profile/Profile';
import Reports from './pages/Reports/Reports';
import Products from './pages/Products/Products';
import IssuedCertificates from './pages/IssuedCertificates/IssuedCertificates';
import IssueCertificate from './pages/IssueCertificates/IssueCertificates';
import Footer from './components/Footer';
import Templates from './pages/Templates/Templates';
import CreateCustomTemplatePage from './pages/Templates/CreateCustomTemplatePage';
import PrivateRoute from './routes/privateRoutes'; // ✅ Add this
import AutoLogoutHandler from './hooks/autoLogout';
import ChangePassword from './pages/Profile/ChangePassword';
import ProductDetail from './pages/Products/ProductDetail';
import IssueWallet from './pages/IssueWallet/IssueWallet';
import UploadExcelPage from './pages/UploadExcel/UploadExcel';
import IssuedWallets from './pages/IssuedWallets/IssuedWallets';
import CertificateView from './pages/ViewCertificate/ViewCertificate';

function Layout({ children, darkMode, setDarkMode }) {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  return (
    <div className={`app ${darkMode ? 'dark' : 'light'}`}>
      {!isLoginPage && <Sidebar />}
      <div className={`main-content ${isLoginPage ? 'no-padding' : ''}`}>
        {!isLoginPage && (
          <Header toggleTheme={() => setDarkMode(!darkMode)} darkMode={darkMode} />
        )}
        {children}
        {!isLoginPage && <Footer />}
      </div>
    </div>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [customTemplates, setCustomTemplates] = useState([]);

  const handleNewTemplate = tpl => {
    setCustomTemplates(prev => [...prev, tpl]);
  };

  return (
    <Router>
      <AutoLogoutHandler /> 
      <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/issue" element={<PrivateRoute><IssueCertificate /></PrivateRoute>} />
          <Route path="/certificates" element={<PrivateRoute><IssuedCertificates /></PrivateRoute>} />
          <Route path="/products" element={<PrivateRoute><Products /></PrivateRoute>} />
          <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/support" element={<PrivateRoute><Support /></PrivateRoute>} />
          <Route path="/templates" element={<PrivateRoute><Templates customTemplates={customTemplates} /></PrivateRoute>} />
          <Route path="/create-custom-template" element={<PrivateRoute><CreateCustomTemplatePage onSave={handleNewTemplate} /></PrivateRoute>} />
          <Route path="/profile/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          <Route path="/products/:id" element={<ProductDetail />} />
           <Route path="/issuewallet" element={<IssueWallet />} />
           <Route path="/wallets" element={<IssuedWallets />} />
           <Route path="/upload-excel" element={<UploadExcelPage />} />
           <Route path="/certificate/view/:id" element={<CertificateView />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
